export const timelineColors = [
  "#004F99",
  "#66B5FF",
  "#D46B08",
  "#08979C",
  "#441C7D",
  "#C41D7F",
  "#389E0D",
  "#FA8C16",
  "#722ED1",
  "#D4B106",
];

export const LINE_CHART_COLORS = {
  SCREENED: "var(--yellow-500)",
  ENROLLED: "var(--pink-500)",
  COMPLETED: "var(--orange-500)",
}

const paletteMapping = {
  50: "#E5F3FF",
  100: "#CCE6FF",
  200: "#99CEFF",
  300: "#66B5FF",
  "300C": "#339CFF",
  400: "#1890FF",
  500: "#096DD9",
  600: "#004F99",
  700: "#003566",
  800: "#001A33",
};

const paletteSequence = [300, 600, 100, 500, 200, 700, 400, 800, 50, "300C"];

const getDarkness = (key) => {
  if (typeof key === "number") return key;
  if (typeof key === "string") {
    return key.endsWith("C") ? parseInt(key) + 0.5 : parseInt(key);
  }
};

export const getPaletteColors = (numCategories) => {
  const selectedShades = paletteSequence.slice(0, numCategories);
  const orderedShades = [...selectedShades].sort(
    (a, b) => getDarkness(b) - getDarkness(a),
  );
  return orderedShades.map((shade) => paletteMapping[shade]);
};
